import { render, staticRenderFns } from "./tests.vue?vue&type=template&id=d6f4372e"
import script from "./tests.vue?vue&type=script&lang=js"
export * from "./tests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports